

<!-- <div *ngIf="sidebar.opened; else closed"> -->

  <h1 class="head" style="text-align: center">社會企業有限公司</h1>
  <img class="roadmap" src="assets/images/roadmap.jpeg" width=100% />
  <img class="roadmaph" src="assets/images/roadmaph.jpeg" width=100% />
<!-- </div> -->

<div class="mnav">
  <div class="col-lg homeCard" col-md-4 routerLink="/ehm" >
    <h2 class="title">
      智保網
      <img class="titleLogo" src="assets/images/laptop_ehm.png" />
    </h2>
    <p>智能院舍, 藥物管理, 電子派藥</p>
  </div>

  <div class="col-lg homeCard" routerLink="/course-registration" >
    <div class="row">
      <h2 class="title">
        HKIE CPD Course Registration
      </h2>
    </div>
  </div>

  <div class="col-lg homeCard" routerLink="/smart">
    <h2 class="title">
      Smart
      <img class="titleLogo" src="assets/images/SI-logo.png" />
      Integration
    </h2>
  </div>

  <div class="col-lg homeCard" col-md-4 routerLink="/hi">
    <img class="titleLogo" src="assets/images/home-care-logo.png" />
    <h2 class="title">
      HI
  </h2>
  HI @ Home
</div>

<div class="col-lg homeCard" routerLink="/training">
  <h2 class="title">
    智保康
    <img class="titleLogo" src="assets/images/pcw_logo.png" />
  </h2>
  <p>証書課程</p>
</div>

<!-- <div class="col-lg homeCard"  routerLink="/course"> -->
          <!-- <span class="badge badge-red badge-corner ">招生</span> -->
  <!-- <h2 class="title">
    資歷架構認可課程 -->
    <!-- <img class="titleLogo" src="assets/images/laptop_ehm.jpg" /> -->
  <!-- </h2> -->
  <!-- <p>2021年9月26日護理員訓練證書開課</p> -->
<!-- </div> -->

<!-- <div class="col-lg homeCard" routerLink="/six-arts">
    <h2 class="title">
      六藝學坊
      <img class="titleLogo" src="assets/images/six_arts_logo.png" />
    </h2>
    <p>興趣班課程</p>
  </div> -->


  <div class="col-lg homeCard"  routerLink="/volunteer">
    <h2 class="title" style="margin-top:45px">
      愛社區義工隊
      <!-- <img class="titleLogo" src="assets/images/laptop_ehm.jpg" /> -->
    </h2>
    <p></p>
  </div>

  <div class="col-lg homeCard"  routerLink="/activity">
    <h2 class="title" style="margin-top:45px">
      社企活動
      <!-- <img class="titleLogo" src="assets/images/laptop_ehm.jpg" /> -->
    </h2>
    <p></p>
  </div>
</div>


<!-- <hr>
<h2>社區活動</h2>
<app-events></app-events> -->

<!-- <hr>
<h2 id='companyEventTitle'>活動畫廊</h2>
<app-activities-photos></app-activities-photos> -->
